import { OrganizationNodepProps } from '@axios/models';
import {
  CHANGE_PWD_SHOW,
  FETCHED_ACCESS_SUCCESS,
  FETCHED_ACCOUNT,
  FETCHED_ACCOUNT_LOADING,
  FETCHED_LODING,
  FETCHED_LOGIN_TYPE,
  FETCHED_ORGS_TREE,
  SWITCH_MENU,
  UPDATE_LOG_STATUS,
  UPDATE_REGIS_SHOW,
  UPDATE_TIMESTAMP_OF_CALLING_API,
  USER_LOGIN
} from '../actions/user.action';
import { AccountModel, ActionModel } from '../models';


export interface UserState {
  isLoding: boolean,
  userInfo: any,
  isLogin: boolean,
  timeStampOfCallingAPI: number
  orgsTree: OrganizationNodepProps[],
  account: AccountModel,
  accountLoading: boolean,
  tokenSuccess: boolean,
  regisShow: boolean,
  loginType: number,
  menuKey:string,
  changePwdShow: boolean
}

const initialState: UserState = {
  userInfo: {},
  isLogin: false,
  timeStampOfCallingAPI: 0,
  orgsTree: [],
  account: {},
  accountLoading: false,
  isLoding: true,
  tokenSuccess: false,
  regisShow: false,
  loginType: 0,
  menuKey:"Index",
  changePwdShow: false
}

export const UserReducer = (state = initialState, action: ActionModel): UserState => {
  switch (action.type) {
    case USER_LOGIN:
      return { ...state, userInfo: action.payload, isLogin: true }
    case UPDATE_LOG_STATUS:
      return { ...state, isLogin: true }
    case UPDATE_TIMESTAMP_OF_CALLING_API:
      return { ...state, timeStampOfCallingAPI: action.payload }
    case FETCHED_ORGS_TREE:
      return { ...state, orgsTree: action.payload }
    case FETCHED_ACCOUNT:
      return { ...state, account: action.payload, isLoding: false }
    case FETCHED_ACCOUNT_LOADING:
      return { ...state, accountLoading: action.payload }
    case FETCHED_ACCESS_SUCCESS:
      return { ...state, tokenSuccess: true }
    case UPDATE_REGIS_SHOW:
      return { ...state, regisShow: action.payload }
    case FETCHED_LOGIN_TYPE:
      return { ...state, loginType: action.payload }
    case FETCHED_LODING:
      return { ...state, isLoding: action.payload }
    case SWITCH_MENU:
      return { ...state, menuKey: action.payload }
    case CHANGE_PWD_SHOW:
      return { ...state, changePwdShow: action.payload }
    default:
      return state
  }
}
